import { call, put, takeEvery } from 'redux-saga/effects';
import {
    addLocationCriteriaSuccess,
    addLocationCriteriaFailure,
} from '../actions/add_location_criteria.actions';
import { ADD_LOCATION_CRITERIA_REQUEST } from '../constants/add_location_criteria.constants';
import { message_error, message_success } from '../../../../../components/Message';
import { addLocationCriteria } from '../../requests/add_location_criteria';

function* addLocationCriteriaRequest({ configId, config }) {
    const {
        result, options, error, msg,
    } = yield call(addLocationCriteria, configId, config);
    if (result) {
        yield put(addLocationCriteriaSuccess(options));
        message_success('Location criteria created successfully!');
    } else {
        yield put(addLocationCriteriaFailure(error));
        message_error(msg);
    }
}

export default function* addLocationCriteriaSaga() {
    yield takeEvery(ADD_LOCATION_CRITERIA_REQUEST, addLocationCriteriaRequest);
}



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Lead-o-matic_location_create/redux/sagas/add_location_criteria.saga.js